module.exports = __webpack_public_path__ + "img/52bc77c.jpg";